import * as actions from '../../actions/actionTypes';
import initialState from '../initialState';

export default function publishDataReducer(
  state = initialState.publishData,
  action
) {
  switch (action.type) {
    case actions.LOAD_PUBLISH_DATA_SUCCESS:
      return action.publishData;
    case actions.LOAD_PUBLISH_DATA_FAILURE:
      return initialState.publishData;
    default:
      return state;
  }
}
